"use strict";

var _ref;

Vue.filter('formatPrice', function (value) {
    return value.toLocaleString("nl-NL", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
});

Vue.filter('formatUnixDate1', function (value) {
    var m  =moment.unix(value);
    m.locale('nl');
    return  m.format("dd D MMMM YYYY, HH:mm");
});

Vue.filter('formatUnixDate2', function (value) {
    var m  =moment.unix(value);
    m.locale('nl');
    return  m.format("YYYY-MM-D HH:mm");
});

Vue.filter('parseJSON', function (value) {
    var jsonString = JSON.stringify(value);
    var jsonObject = JSON.parse(jsonString);
    return jsonObject;
});

var app = new Vue({
    el: '#newsitems',
    data: {
        started: false,
        searchTerm: '',
        cdnpath: cdnpath,
        categoryID: null,
        currentFacet: null,
        results: null,
        categories: null,
        offset: 0,
        limit: 21,
        stringLimit: "",
        selectedSort: '',
        pages: [],
        pageCount: null,
        page: 0,
        total: 0,
        start: 0,
        end: 0,
        culture: 'nl-NL',
        filters: [],
        meilisearchFilters: [[]],
        facetFilters: [[]],
        pageSizes: (_ref = [40, 80, 120, 240], _ref),
        initialFilters: null
    },
    computed: {
        hasPages: function hasPages() {
            return this.pageCount > 1;
        }
    },
    methods: {
        trimText: function trimText(value) {
            if(!value)
                return "";
            var limit = 400;
            if(value.length > limit) 
            {
                value = value.substring(0, limit) + '...';
            }
            return value;
        },
        parseJson: function parseJson(value) {
            //const jsonString = JSON.stringify(value)
            var jsonString = JSON.stringify(value);
            var jsonObject = JSON.parse(jsonString);
            return jsonObject;
        },
        showFromPriceDiscount: function showFromPriceDiscount(value) {
            return value.FromPrice > 0 && value.DiscountsJson === "[]";
        },
        getIndex: function getIndex() {
            if (this.selectedSort.length == 0) {
                return 'newsitems';
            } else {
                return this.selectedSort;
            }
        },
        getResults: function getResults(nameOfClickedFilter, includeDistributions) {
            var _this = this; //Get array with checked filters

            this.getFilters(); //Save cheched filters for later

            var previousFilters = this.meilisearchFilters;
            var url = '/api/search/' + this.getIndex();
            var offset = (this.page - 1) * this.limit;
            var data = {};
            data.SearchTerm = this.searchTerm;
            data.Offset = offset;
            data.Limit = this.limit;
            data.FacetFilters = this.meilisearchFilters;
            data.DistributionSelection = this.categoryID;
            data.IncludeDistributions = includeDistributions;
            var currentUrl = window.location.href;
            var urlSplit = currentUrl.split("?");
            var state = {
                Title: document.title,
                Limit: this.limit,
                Page: this.page,
                Sort: this.selectedSort,
                Filters: JSON.stringify(this.facetFilters),
                Search: this.searchTerm
            };
            var newUrl = urlSplit[0] + "?pagesize=" + this.limit + "&sort=" + this.selectedSort + "&page=" + this.page + "&filters=" + state.Filters;

            if (this.searchTerm && this.searchTerm.length > 0) {
                newUrl = newUrl + "&q=" + this.searchTerm;
            }

            history.replaceState(state, state.Title, newUrl);

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            }).then(function (res) {
                return res.json();
            }).then(function (res) {
                _this.results = res.Hits;
                _this.total = res.NbHits;
                _this.start = offset + 1;
                _this.end = Math.min(offset + _this.limit, _this.total);
                _this.pageCount = Math.ceil(_this.total / _this.limit);

                _this.fillFilters(res.FacetsDistribution, false, previousFilters, nameOfClickedFilter);

                _this.setPages();

                _this.started = true;
            })["catch"](function (e) {
                console.error(e.message);
            });

            if (this.stringLimit === "Alles") {
                this.limit = this.stringLimit;
            }
        },
        setPages: function setPages() {
            this.pages = [];
            this.pages.push({
                "Number": 1,
                "Active": this.page == 1
            });
            var first = Math.max(2, this.page - 2);
            var last = Math.min(this.pageCount, this.page + 3);

            if (first > 2) {
                this.pages.push({
                "Number": 0
                });
            }

            for (var p = first; p < last; p++) {
                this.pages.push({
                "Number": p,
                "Active": this.page == p
                });
            }

            if (last < this.pageCount - 1) {
                this.pages.push({
                "Number": 0
                });
            }

            this.pages.push({
                "Number": this.pageCount,
                "Active": this.page == this.pageCount
            });
        },
        toggleFacetGroup: function toggleFacetGroup() {
            $(this).next().slideToggle('slow');
            $(this).toggleClass("active");
            $(this).next().show();
            return false;
        },
        getInitialFacetFilters: function getInitialFacetFilters() {
            var _this2 = this; //Get array with checked filters

            this.getFilters(); //Save cheched filters for later

            var previousFilters = this.meilisearchFilters;
            var p = [];
            var distributionsRequest1 = this.getDistributions(this.meilisearchFilters);
            p.push(distributionsRequest1);

            if (_this2.initialFilters && _this2.initialFilters.length > 0) {
                if (_this2.categoryID.length > 0) {
                _this2.initialFilters.push("CategoryIDs=" + _this2.categoryID);
                }

                if (_this2.currentFacet && _this2.currentFacet.length > 0) {
                _this2.initialFilters.push(_this2.currentFacet);
                }

                var distributionsRequest2 = this.getDistributions(_this2.initialFilters);
                p.push(distributionsRequest2);
            }

            Promise.all(p).then(function (results) {
                return Promise.all(results.map(function (r) {
                    return r.json();
                })).then(function (results) {
                    var dist1 = results[0].FacetsDistribution;
                    var dist2;
                    if (results.length > 1) dist2 = results[1].FacetsDistribution;

                    _this2.fillFilters(dist1, true, _this2.initialFilters, null, dist2);
                });
            });
        },
        getDistributions: function getDistributions(filters) {
            var url = '/api/search/' + this.getIndex();
            var data = {};
            data.SearchTerm = this.searchTerm;
            data.Offset = 0;
            data.Limit = 0;
            data.FacetFilters = filters;
            data.DistributionSelection = this.categoryID;
            data.IncludeDistributions = false;
            return fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            });
        },
        toggleFacet: function toggleFacet(e, facetName) {
            e.preventDefault();
            this.page = 1;
            this.getResults(facetName, true);
        },
        prevPage: function prevPage(e) {
            e.preventDefault();
            if (this.page > 1) this.page--;else this.page = this.pageCount;
            this.scrollUp();
            this.getResults(null, false);
        },
        nextPage: function nextPage(e) {
            e.preventDefault();
            if (this.page < this.pageCount) this.page++;else this.page = 1;
            this.scrollUp();
            this.getResults(null, false);
        },
        setPage: function setPage(page, e) {
            e.preventDefault();
            this.page = page.Number;
            this.scrollUp();
            this.getResults(null, false);
        },
        sort: function sort() {
            this.page = 1;
            this.scrollUp();
            this.getResults(null, false);
        },
        setLimit: function setLimit() {
            if (this.limit === "Alles") {
                this.limit = this.total;
                this.stringLimit = "Alles";
            }

            this.page = 1;
            this.scrollUp();
            this.getResults(null, false);
        },
        scrollUp: function scrollUp() {
            $('html, body').animate({
                scrollTop: Math.round($(".scrollTopTarget").offset().top - $(".js-header").outerHeight())
            }, 200);
        },
        getFilters: function getFilters() {
            this.meilisearchFilters = [];
            this.facetFilters = [];

            for (var i = 0; i < this.filters.length; i++) {
                this.meilisearchFilters.push([]);
                var latestArrayIndex = this.meilisearchFilters.length - 1;

                for (var x = 0; x < this.filters[i].Distribution.length; x++) {
                if (this.filters[i].Distribution[x].Checked) {
                    this.meilisearchFilters[latestArrayIndex].push(this.filters[i].Name + "=" + this.filters[i].Distribution[x].Key);
                }
                }
            } //Remove empty filterarrays    


            this.meilisearchFilters = this.meilisearchFilters.filter(function (array) {
                return array.length != 0;
            });
            this.facetFilters = this.meilisearchFilters.slice();

            if (this.categoryID.length > 0) {
                this.meilisearchFilters.push("CategoryIDs=" + this.categoryID);
            }

            if (this.currentFacet && this.currentFacet.length > 0) {
                this.meilisearchFilters.push(this.currentFacet);
            }
        },
        fillFilters: function fillFilters(facetsDistribution, initialLoad, previousFilters, nameOfClickedFilter, facetsDistribution1) {
            var _this3 = this;

            if (facetsDistribution === undefined) {
                facetsDistribution = [];
            } //Remove empty filterarrays

            var removeBrandTitle = this.currentFacet && this.currentFacet.length > 0;

            if (facetsDistribution.length > 0) {
                facetsDistribution = facetsDistribution.filter(function (array) {
                var valid = array.Distribution.length > 0;

                if (valid && removeBrandTitle) {
                    valid = array.Name != 'BrandTitle';
                }

                return valid;
                }); //If it's the first load, set 'checked'-value for all filters to false
            }

            if (initialLoad) {
                this.filters = facetsDistribution;

                var _loop = function _loop(i) {
                    _this3.filters[i].Hidden = false;

                    if (previousFilters && facetsDistribution1) {
                        var newFilterIndex = facetsDistribution1.findIndex(function (x) {
                            return x.Name == _this3.filters[i].Name;
                        });

                        if (newFilterIndex > -1) {
                            _this3.filters[i] = facetsDistribution1[newFilterIndex];

                            if (_this3.filters[i].Distribution.length == 0) {
                                _this3.filters[i].Hidden = true;
                            } else {
                                for (var x = 0; x < _this3.filters[i].Distribution.length; x++) {
                                //Go through all distrubitions and see if they we're previously checked
                                var FilterWasPreviouslyChecked = false;

                                for (var z = 0; z < previousFilters.length; z++) {
                                    //If previously checked, set checked to true;
                                    if (previousFilters[z].includes(_this3.filters[i].Name + "=" + _this3.filters[i].Distribution[x].Key)) {
                                    FilterWasPreviouslyChecked = true;
                                    }
                                } //Set checked value to true or false (depending on previously checked or not)


                                _this3.filters[i].Distribution[x].Checked = FilterWasPreviouslyChecked;
                                }
                            }
                        } else {
                            _this3.filters[i].Hidden = true;
                        }
                    } else {
                        for (var _x = 0; _x < _this3.filters[i].Distribution.length; _x++) {
                            _this3.filters[i].Distribution[_x].Checked = false;
                        }
                    }
                };

                for (var i = 0; i < this.filters.length; i++) {
                    _loop(i);
                }
            } else if (nameOfClickedFilter) {
                var _loop2 = function _loop2(_i) {
                    _this3.filters[_i].Hidden = false; //Make sure last checked filter list does not get updated

                if (_this3.filters[_i].Name !== nameOfClickedFilter) {
                    //Find index of current filter
                    var newFilterIndex = facetsDistribution.findIndex(function (x) {
                        return x.Name == _this3.filters[_i].Name;
                    });

                    if (newFilterIndex > -1) {
                        _this3.filters[_i] = facetsDistribution[newFilterIndex];

                        for (var x = 0; x < _this3.filters[_i].Distribution.length; x++) {
                            //Go through all distrubitions and see if they we're previously checked
                            var FilterWasPreviouslyChecked = false;

                            for (var z = 0; z < previousFilters.length; z++) {
                                //If previously checked, set checked to true;
                                if (previousFilters[z].includes(_this3.filters[_i].Name + "=" + _this3.filters[_i].Distribution[x].Key)) {
                                    FilterWasPreviouslyChecked = true;
                                }
                            } //Set checked value to true or false (depending on previously checked or not)

                            _this3.filters[_i].Distribution[x].Checked = FilterWasPreviouslyChecked;
                        }
                    } else {
                        _this3.filters[_i].Hidden = true; //this.filters.splice(i, 1);
                        //i--;
                    }
                }
            }; //If it's NOT the first load, check what filters need to be changed and which ones we're previously checked

            for (var _i = 0; _i < this.filters.length; _i++) {
                _loop2(_i);
            }
        }
        }
    },
    mounted: function mounted() {
        this.categoryID = _categoryID;
        this.currentFacet = _currentFacet;
        this.searchTerm = _searchTerm;
        this.selectedSort = _sort;
        this.limit = _pageSize;
        this.total = _total;
        this.start = _start;
        this.end = _end;
        this.page = _page;
        this.pageCount = _pageCount;

        if (_filters && _filters.length > 0) {
            this.initialFilters = JSON.parse(_filters);
        }

        this.getInitialFacetFilters();
        this.setPages();
    }
});